import { AccountContextProvider } from './AccountContext';
import { LanguageContextProvider } from './LanguageContext';
import { NavigationContextProvider } from './NavigationContext';
import { ToastContextProvider } from './ToastContext';
import { ImageCompressingContextProvider } from './ImageCompressingContext';

const AppContexts = ({ children }) => (
  <AccountContextProvider>
    <ToastContextProvider>
      <NavigationContextProvider>
        <LanguageContextProvider>
          <ImageCompressingContextProvider>{children}</ImageCompressingContextProvider>
        </LanguageContextProvider>
      </NavigationContextProvider>
    </ToastContextProvider>
  </AccountContextProvider>
);

export default AppContexts;
